import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthContext';
import { useOrgSettings } from '@/shared/context/OrgSettingsContext';

interface OrganizationCheckProps {
  children: React.ReactNode;
}

const OrganizationCheck: React.FC<OrganizationCheckProps> = ({ children }) => {
  const { user, token, clearAuthData } = useAuth();
  const { loading: orgSettingsLoading, orgExists } = useOrgSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const forcePasswordChange = Boolean(user?.forcePasswordChange);
  const mustEnrollTwoFactor = Boolean(user?.mustEnrollTwoFactor);

  useEffect(() => {
    if (!token || !user || orgSettingsLoading || orgExists) return;
    clearAuthData();
    navigate('/login', { replace: true });
  }, [token, user, orgSettingsLoading, orgExists, clearAuthData, navigate]);

  useEffect(() => {
    if (!user) return;

    if (forcePasswordChange) {
      navigate('/change-password');
      return;
    }

    if (mustEnrollTwoFactor) {
      const onProfileAccount =
        location.pathname.startsWith('/profile') &&
        new URLSearchParams(location.search).get('tab') === 'account';
      if (!onProfileAccount) {
        navigate('/profile?tab=account', { replace: true });
      }
    }
  }, [forcePasswordChange, mustEnrollTwoFactor, user, navigate, location.pathname, location.search]);

  if (forcePasswordChange) {
    return null;
  }

  return <>{children}</>;
};

export default OrganizationCheck;
